/**
 * <s-sticky-atc> — mobile add-to-cart bar that appears once the main buy button scrolls out of view.
 *
 * Required markup:
 *   data-watch="<selector>" — the main add-to-cart button to watch
 *   button[form]            — submits the main product form, so cart logic stays in one place
 */
class SStickyAtc extends HTMLElement {
  #observer;

  connectedCallback() {
    const target = document.querySelector(this.dataset.watch || '');
    if (!target) return;
    this.#observer = new IntersectionObserver(([entry]) => {
      const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      this.toggleAttribute('data-visible', scrolledPast);
      this.inert = !scrolledPast;
    });
    this.inert = true;
    this.#observer.observe(target);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('s-sticky-atc')) {
  customElements.define('s-sticky-atc', SStickyAtc);
}
